import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { X } from "lucide-react";
import { toast } from "sonner";

export default function ResetPasswordModal({ employee, onClose }) {
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { setErr("Password must be at least 8 characters"); return; }
    if (pw !== pw2) { setErr("Passwords do not match"); return; }
    setBusy(true); setErr("");
    try {
      await api.post(`/employees/${employee.id}/reset-password`, { new_password: pw });
      toast.success(`Password reset for ${employee.first_name} ${employee.last_name}`);
      onClose();
    } catch (e) {
      setErr(formatApiError(e));
    } finally { setBusy(false); }
  };

  const genRandom = () => {
    const words = "aeioubcdfghjklmnpqrstvwxyz";
    let out = "";
    for (let i = 0; i < 10; i++) out += words[Math.floor(Math.random() * words.length)];
    out += Math.floor(Math.random() * 100);
    out = out[0].toUpperCase() + out.slice(1) + "!";
    setPw(out); setPw2(out);
  };

  return (
    <div className="fixed inset-0 bg-ink/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white border-2 border-ink w-full max-w-md shadow-hard-lg">
        <div className="flex items-center justify-between border-b-2 border-ink px-5 py-4">
          <div>
            <div className="overline">§ RESET PASSWORD</div>
            <h2 className="font-heading font-black text-xl">{employee.first_name} {employee.last_name}</h2>
          </div>
          <button onClick={onClose} data-testid="close-reset-modal" className="p-2 border-2 border-ink hover:bg-ink hover:text-white"><X className="w-4 h-4" /></button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-4">
          <div className="border-2 border-warn bg-warn/10 p-3 font-mono text-xs">
            Employee <b>{employee.email}</b> will be notified by email that their password has been reset.
          </div>
          <label className="block">
            <div className="overline mb-2">New Password (min 8 chars)</div>
            <input data-testid="reset-new-password" type="text" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full px-3 py-2 border-2 border-ink font-mono text-sm" required minLength={8} />
          </label>
          <label className="block">
            <div className="overline mb-2">Confirm Password</div>
            <input data-testid="reset-confirm-password" type="text" value={pw2} onChange={(e) => setPw2(e.target.value)} className="w-full px-3 py-2 border-2 border-ink font-mono text-sm" required minLength={8} />
          </label>
          <button type="button" onClick={genRandom} className="w-full py-2 border-2 border-ink font-mono text-xs uppercase tracking-widest hover:bg-secondary">Generate Secure Random</button>
          {err && <div className="border-2 border-bad text-bad font-mono text-xs p-2">{err}</div>}
          <div className="flex justify-end gap-3 pt-3 border-t-2 border-ink">
            <button type="button" onClick={onClose} className="px-4 py-2 border-2 border-ink font-mono text-xs uppercase tracking-widest">Cancel</button>
            <button data-testid="submit-reset-password" disabled={busy} type="submit" className="hard-btn px-4 py-2 font-mono text-xs uppercase tracking-widest">{busy ? "Resetting…" : "Reset Password"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
